import React, { useState, useEffect, useMemo } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import StatusBadge from "../common/StatusBadge";
import Loader from "../common/Loader";
import DocumentCard from "../common/DocumentCard";
import FilePreviewModal from "../common/FilePreviewModal";

import fileUtils from "../../utils/fileUtils";

import "bootstrap-icons/font/bootstrap-icons.css";
import "../../styles/GrievanceDetails.css";
import {
  fetchApplicantDetails,
  fetchGrantById,
  updateGrantStatus,
  fetchGrantStatusOptions,
} from "../../redux/actions/grievanceActions1";
import TimeLineItem2 from "../common/TimeLineItem2";

const EscalatedGrantsDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  const { esm, centerName, id, grnatDetails } = location.state;
  const { applicantDetails, selectedGrant, loading } = useSelector(
    (state) => state.grievances
  );
  console.log(applicantDetails, "applicantDetails");
  const { user } = useSelector((state) => state.grievances);
  const currentStatusId =
    selectedGrant?.STATUS_ID || grnatDetails?.STATUS_ID || "10";
  const [updateStatus, setUpdateStatus] = useState("");
  const [comments, setComments] = useState("");
  const [fileName, setFileName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [fileMetadata, setFileMetadata] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [activeTab, setActiveTab] = useState("overview");
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewAttachment, setPreviewAttachment] = useState(null);

  useEffect(() => {
    if (id) {
      dispatch(fetchApplicantDetails(esm));
      dispatch(fetchGrantById(id));

      dispatch(fetchGrantStatusOptions());
    }
  }, [id, dispatch]);

  useEffect(() => {
    let timer;
    if (successMessage) {
      timer = setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [successMessage]);

  const isEducationGrant = useMemo(() => {
    if (!selectedGrant) return false;

    return (
      selectedGrant.grantType === "HIGHER EDN GRANT" ||
      Boolean(selectedGrant.collegeUniversityName) ||
      Boolean(selectedGrant.schoolName)
    );
  }, [selectedGrant]);

  const resetForm = () => {
    setUpdateStatus("");
    setComments("");
    setFileMetadata([]);
  };

  const closePreviewModal = () => {
    setIsPreviewModalOpen(false);
    setPreviewAttachment("");
  };

  const handleApproveGrant = async () => {
    if (!comments) {
      setErrorMessage("Please add remarks before approving the grant");
      return;
    }

    setIsSubmitting(true);
    setSuccessMessage("");
    setErrorMessage("");

    try {
      const files = fileMetadata.filter((meta) => meta instanceof File);

      let apiAttachments = [];
      if (files.length > 0) {
        apiAttachments = await fileUtils.filesToAttachments(files);
      }

      const statusId = "13";

      console.log(id, statusId, comments, user?.id);
      const res = await dispatch(
        updateGrantStatus(id, statusId, comments, user?.id || "0", files)
      );

      if (res.rCode == 0) {
        alert(res.rMessage || "Grants Updated successfully");
        navigate("/EscalatedGrants");
        resetForm();
        await dispatch(fetchGrantById(id));
      } else {
        alert(res.rMessage || "error");
      }
    } catch (error) {
      setErrorMessage(error.message || "Failed to approve grant");

      dispatch(fetchGrantById(id));
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleTimelineAttachmentPreview = (state, attachment, name) => {
    setIsLoading(state);
    setPreviewAttachment(attachment);
    setFileName(name);
    if (!state) {
      setIsPreviewModalOpen(true);
    }
  };

  const isGrantInFinalState = () => {
    if (!selectedGrant) return false;

    const statusId = selectedGrant.statusId || "";

    if (statusId === "3" || statusId === "5" || statusId === "7") {
      return true;
    }

    if (statusId === "12" || statusId === "16" || statusId === "17") {
      return true;
    }

    return false;
  };

  if (loading || !selectedGrant) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <Loader message="Loading grant details..." />
      </div>
    );
  }

  const getAllAttachments = () => {
    const attachments = [];
    if (selectedGrant?.updates) {
      for (const update of selectedGrant.updates) {
        if (update?.attachments && update.attachments.length > 0) {
          attachments.push(...update.attachments);
        }
      }
    }
    return attachments;
  };

  const allAttachments = getAllAttachments();

  const getGrantTypeFields = (grantType) => {
    const commonFields = [
      { key: "USER_NAME", label: "Applicant Name" },
      { key: "UNIT_CENTRE_NAME", label: "Center Name" },
      { key: "BRANCH_NAME", label: "Branch Name" },
      { key: "ENTRY_DATETIME", label: "Submission Date" },
      { key: "GRANT_TYPE", label: "Grant Type" },
      { key: "STATUS_NAME", label: "Current Status" },
      { key: "REMARKS", label: "Remarks" },
    ];

    const bankFields = [
      // { key: 'BANK_NAME', label: 'Bank Name' },
      { key: "ACCOUNT_HOLDER_NAME", label: "Account Holder Name" },
      { key: "BANK_ACCOUNT_NO", label: "Bank Account Number" },
      { key: "IFSC_CODE", label: "IFSC Code" },
      { key: "CONTACT_NO", label: "Contact Number" },
    ];

    switch (grantType?.toUpperCase()) {
      case "SCHOOL EDN GRANT":
        return [
          ...commonFields,
          { key: "STUDENT_NAME", label: "Student Name" },
          { key: "DOB", label: "Date of Birth" },
          { key: "CURRENT_CLASS", label: "Current Class" },
          { key: "TUITION_FEE", label: "Tuition Fee" },
          { key: "ADDRESS", label: "Address" },
          { key: "SCHOOL_NAME", label: "School Name" },
          { key: "SCHOOL_ADDRESS", label: "School Address" },
          { key: "TOTAL_ACADEMIC_AMOUNT", label: "Total Academic Amount" },
          ...bankFields,
        ];

      case "HIGHER EDN GRANT":
        return [
          ...commonFields,
          // { key: 'PENSION_AMOUNT', label: 'Pension Amount' },
          {
            key: grnatDetails.PENSION_AMOUNT
              ? "PENSION_AMOUNT"
              : "RELIEF_AMOUNT",
            label: grnatDetails.PENSION_AMOUNT
              ? "Pension Amount"
              : "Pension Amount",
          },
          { key: "EARLIER_PAYMENT", label: "Earlier Payment" },
          { key: "STUDENT_NAME", label: "Student Name" },
          { key: "DOB", label: "Date of Birth" },
          { key: "COLLEGE_UNIVERSITY_NAME", label: "College/University Name" },
          {
            key: "COLLEGE_UNIVERSITY_ADDRESS",
            label: "College/University Address",
          },
          { key: "CURRENT_CLASS", label: "Current Class" },
          { key: "TOTAL_ACADEMIC_AMOUNT", label: "Total Academic Amount" },
          { key: "PREVIOUS_EXAM_RESULT", label: "Previous Exam Result" },
          ...bankFields,
        ];

      case "NATURAL CALAMITY (OTG)":
      case "MARRIAGE GRANT":
      case "FUNERAL GRANT":
      case "OLD AGE GRANT":
        return [
          ...commonFields,
          { key: "CAUSE_OF_DISCHARGE", label: "Cause of Discharge" },
          { key: "RELATION_NAME", label: "Relationship" },
          { key: "PARTICULARS_DEPENDENTS", label: "Particulars of Dependents" },
          { key: "GROUNDS_FOR_RELIEF", label: "Grounds for Relief" },
          { key: "PENSION_AMOUNT", label: "Pension Amount" },
          { key: "EARLIER_PAYMENT", label: "Earlier Payment" },
          { key: "DISABILITY", label: "Disability" },
          { key: "RELIEF_AMOUNT", label: "Relief Amount" },
          ...bankFields,
        ];

      case "MEDICAL AID GRANT":
        return [
          ...commonFields,
          { key: "PATIENT_NAME", label: "Patient Name" },
          { key: "RELATION_NAME", label: "Relationship" },
          { key: "DOB", label: "Date of Birth" },
          { key: "DISEASE_SUFERRING_FROM", label: "Disease Suffering From" },
          { key: "DOCTOR_NAME", label: "Doctor Name" },
          { key: "HOSPITAL_NAME", label: "Hospital Name" },
          { key: "HOSPITAL_ADMIT_DATE", label: "Hospital Admit Date" },
          { key: "HOSPITAL_DISCHARGE_DATE", label: "Hospital Discharge Date" },
          // { key: "NEARBY_GOVT_HOSPITAL", label: "Nearby Government Hospital" },
          { key: "RELIEF_AMOUNT", label: "Relief Amount" },
          ...bankFields,
        ];

      default:
        return [
          ...commonFields,
          { key: "PENSION_AMOUNT", label: "Pension Amount" },
          { key: "RELIEF_AMOUNT", label: "Relief Amount" },
        ];
    }
  };

  const fieldsToShow = getGrantTypeFields(grnatDetails?.GRANT_TYPE);

  const formatValue = (value) => {
    if (!value || value === "N/A" || value === "") return "N/A";
    return value;
  };

  const getGrantTypeColor = (grantType) => {
    switch (grantType?.toUpperCase()) {
      case "SCHOOL EDN GRANT":
        return "badge bg-primary";
      case "HIGHER EDN GRANT":
        return "badge bg-success";
      case "NATURAL CALAMITY (OTG)":
        return "badge bg-warning";
      case "MEDICAL GRANT":
        return "badge bg-danger";
      case "MARRIAGE":
        return "badge bg-info";
      case "FUNERAL":
        return "badge bg-dark";
      case "OLD AGE":
        return "badge bg-secondary";
      default:
        return "badge bg-light text-dark";
    }
  };
  return (
    <div className="grievance-details-container">
      <FilePreviewModal
        isOpen={isPreviewModalOpen}
        onClose={closePreviewModal}
        attachment={previewAttachment}
        fileTypes={fileName}
      />

      <div className="grievance-details-header">
        <div style={{ display: "flex", flexDirection: "row", gap: 30 }}>
          <button
            className="fab-button"
            onClick={() => navigate("/EscalatedGrants")}
            title="Back to grants"
          >
            <i className="bi bi-arrow-left"></i>
          </button>
          <div className="grievance-details-title">
            <div className="title-icon">
              <i className="bi bi-clipboard-check"></i>
            </div>
            <div>
              <h2>
                C
                {(selectedGrant?.APP_ID || grnatDetails?.APP_ID)
                  ?.toString()
                  .padStart(10, "0")}
              </h2>
              <p className="grievance-subtitle">
                {selectedGrant?.GRANT_TYPE || grnatDetails?.GRANT_TYPE} •{" "}
                {selectedGrant?.ENTRY_DATETIME || grnatDetails?.ENTRY_DATETIME}
              </p>
            </div>
          </div>
        </div>
        <StatusBadge
          status={selectedGrant?.current_status_name}
          size="large"
          color="#000"
        />
      </div>

      <div className="grievance-details-tabs">
        <button
          className={`tab-button ${activeTab === "overview" ? "active" : ""}`}
          onClick={() => setActiveTab("overview")}
        >
          <i className="bi bi-info-circle"></i> Overview
        </button>
        <button
          className={`tab-button ${
            activeTab === "grantDetails" ? "active" : ""
          }`}
          onClick={() => setActiveTab("grantDetails")}
        >
          <i className="bi bi-info-circle"></i> Grant Details
        </button>
        <button
          className={`tab-button ${activeTab === "timeline" ? "active" : ""}`}
          onClick={() => setActiveTab("timeline")}
        >
          <i className="bi bi-clock-history"></i> Status Trail
          {selectedGrant?.updates?.length > 0 && (
            <span className="tab-badge">{selectedGrant?.updates?.length}</span>
          )}
        </button>
        <button
          className={`tab-button ${activeTab === "documents" ? "active" : ""}`}
          onClick={() => setActiveTab("documents")}
        >
          <i className="bi bi-file-earmark"></i> Documents
          {allAttachments?.length > 0 && (
            <span className="tab-badge">{allAttachments?.length}</span>
          )}
        </button>
        {!isGrantInFinalState() && (
          <button
            className={`tab-button ${activeTab === "update" ? "active" : ""}`}
            onClick={() => setActiveTab("update")}
          >
            <i className="bi bi-pencil-square"></i> Update Progress
          </button>
        )}
      </div>

      <div className="grievance-details-content">
        {activeTab === "overview" && (
          <div className="grievance-details-panel">
            {/* Applicant Information Card */}
            <div className="grievance-details-card applicant-card">
              <div className="card-header">
                <h3>
                  <i className="bi bi-person"></i> Applicant Information
                </h3>
                <div className="card-avatar">
                  <span>
                    {(
                      selectedGrant?.USER_NAME || grnatDetails?.USER_NAME
                    )?.charAt(0) || "U"}
                  </span>
                </div>
              </div>
              <div className="card-body">
                <div className="applicant-name">
                  {selectedGrant?.USER_NAME || grnatDetails?.USER_NAME}
                </div>

                <div className="info-grid">
                  <div className="info-item">
                    <div className="info-icon">
                      <i className="bi bi-calendar2"></i>
                    </div>
                    <div>
                      <div className="info-label">Submission Date</div>
                      <div className="info-value">
                        {selectedGrant?.ENTRY_DATETIME ||
                          grnatDetails?.ENTRY_DATETIME ||
                          "N/A"}
                      </div>
                    </div>
                  </div>

                  <div className="info-item">
                    <div className="info-icon">
                      <i className="bi bi-building"></i>
                    </div>
                    <div>
                      <div className="info-label">ARESA Center</div>
                      <div className="info-value">
                        {selectedGrant?.UNIT_CENTRE_NAME ||
                          grnatDetails?.UNIT_CENTRE_NAME ||
                          centerName ||
                          "N/A"}
                      </div>
                    </div>
                  </div>

                  <div className="info-item">
                    <div className="info-icon">
                      <i className="bi bi-currency-rupee"></i>
                    </div>
                    <div>
                      <div className="info-label">Pension Amount</div>
                      <div className="info-value">
                        ₹
                        {selectedGrant?.PENSION_AMOUNT ||
                          grnatDetails?.PENSION_AMOUNT ||
                          "0"}
                      </div>
                    </div>
                  </div>

                  <div className="info-item">
                    <div className="info-icon">
                      <i className="bi bi-currency-rupee"></i>
                    </div>
                    <div>
                      <div className="info-label">Relief Amount</div>
                      <div className="info-value">
                        ₹
                        {selectedGrant?.RELIEF_AMOUNT ||
                          grnatDetails?.RELIEF_AMOUNT ||
                          "0"}
                      </div>
                    </div>
                  </div>

                  {isEducationGrant && (
                    <>
                      {(selectedGrant?.schoolName ||
                        grnatDetails?.schoolName) && (
                        <div className="info-item">
                          <div className="info-icon">
                            <i className="bi bi-book"></i>
                          </div>
                          <div>
                            <div className="info-label">School Name</div>
                            <div className="info-value">
                              {selectedGrant?.schoolName ||
                                grnatDetails?.schoolName}
                            </div>
                          </div>
                        </div>
                      )}

                      {(selectedGrant?.collegeUniversityName ||
                        grnatDetails?.collegeUniversityName) && (
                        <div className="info-item">
                          <div className="info-icon">
                            <i className="bi bi-building"></i>
                          </div>
                          <div>
                            <div className="info-label">College/University</div>
                            <div className="info-value">
                              {selectedGrant?.collegeUniversityName ||
                                grnatDetails?.collegeUniversityName}
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Grant Details Card */}
            <div className="grievance-details-card description-card">
              <div className="card-header">
                <h3>
                  <i className="bi bi-chat-left-text"></i> Grant Details
                </h3>
              </div>
              <div className="card-body">
                <div className="category-badge">
                  <i className="bi bi-tag-fill"></i>
                  <span>
                    {selectedGrant?.GRANT_TYPE || grnatDetails?.GRANT_TYPE}
                  </span>
                </div>

                <div className="description-box">
                  <div className="description-title">
                    <i className="bi bi-card-text"></i> Remarks
                  </div>
                  <div className="description-content">
                    {selectedGrant?.REMARKS ||
                      grnatDetails?.REMARKS ||
                      "No remarks provided"}
                  </div>
                </div>

                <div className="status-action-section">
                  <div className="current-status">
                    <p className="status-label">Current Status</p>
                    <StatusBadge
                      status={selectedGrant?.current_status_name}
                      size="large"
                      color="#000"
                    />
                  </div>

                  <button
                    className="button primary"
                    onClick={() => setActiveTab("update")}
                  >
                    <i className="bi bi-pencil-square"></i>
                    Update Status
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

{activeTab === "grantDetails" && (
          <div className="grievance-details-panel full-width">
            <div className="grievance-details-card">
              <div className="card-header">
                <h3>
                  <i className="bi bi-info-circle"></i> Grant Details
                </h3>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-hover table-bordered">
                    <tbody>
                      {fieldsToShow.reduce((rows, field, index) => {
                        if (index % 2 === 0) {
                          const nextField = fieldsToShow[index + 1];
                          rows.push(
                            <tr key={index}>
                              {/* First column pair */}
                              <th className="text-nowrap bg-light" style={{ width: "20%" }}>
                                {field.label}
                              </th>
                              <td style={{ width: "30%" }}>
                                {field.key === "GRANT_TYPE" ? (
                                  <span className={getGrantTypeColor(grnatDetails?.[field.key])}>
                                    {formatValue(grnatDetails?.[field.key])}
                                  </span>
                                ) : field.key === "STATUS_NAME" ? (
                                  <span className="badge bg-success">
                                    {formatValue(grnatDetails?.[field.key])}
                                  </span>
                                ) : field.key.includes("AMOUNT") || field.key.includes("FEE") ? (
                                  <span className="fw-bold text-success">
                                    ₹{formatValue(grnatDetails?.[field.key])}
                                  </span>
                                ) : (
                                  formatValue(grnatDetails?.[field.key])
                                )}
                              </td>
                              
                              {/* Second column pair */}
                              {nextField ? (
                                <>
                                  <th className="text-nowrap bg-light" style={{ width: "20%" }}>
                                    {nextField.label}
                                  </th>
                                  <td style={{ width: "30%" }}>
                                    {nextField.key === "GRANT_TYPE" ? (
                                      <span className={getGrantTypeColor(grnatDetails?.[nextField.key])}>
                                        {formatValue(grnatDetails?.[nextField.key])}
                                      </span>
                                    ) : nextField.key === "STATUS_NAME" ? (
                                      <span className="badge bg-success">
                                        {formatValue(grnatDetails?.[nextField.key])}
                                      </span>
                                    ) : nextField.key.includes("AMOUNT") || nextField.key.includes("FEE") ? (
                                      <span className="fw-bold text-success">
                                        ₹{formatValue(grnatDetails?.[nextField.key])}
                                      </span>
                                    ) : (
                                      formatValue(grnatDetails?.[nextField.key])
                                    )}
                                  </td>
                                </>
                              ) : (
                                // Empty cells if odd number of fields
                                <>
                                  <th className="bg-light"></th>
                                  <td></td>
                                </>
                              )}
                            </tr>
                          );
                        }
                        return rows;
                      }, [])}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === "timeline" && (
          <div className="grievance-details-panel full-width">
            <div className="grievance-details-card">
              <div className="card-header">
                <h3>
                  <i className="bi bi-clock-history"></i> Grant Timeline
                </h3>
              </div>
              <div className="card-body">
                {selectedGrant?.updates?.length > 0 ? (
                  <div className="timeline-container">
                    {selectedGrant.updates.map((entry, index) => (
                      <TimeLineItem2
                        key={index}
                        status_name={entry.status_name}
                        action={entry.remarks}
                        date={entry.entry_datetime}
                        comments={entry.remarks}
                        attachments={entry.attachments}
                        user_name={entry.user_name}
                        onPreviewAttachment={handleTimelineAttachmentPreview}
                        isLast={index === selectedGrant.updates.length - 1}
                        isFirst={index === 0}
                        isLoading={isLoading}
                        type="grant"
                      />
                    ))}
                  </div>
                ) : (
                  <div className="empty-state">
                    <div className="empty-icon">
                      <i className="bi bi-clock-history"></i>
                    </div>
                    <p>No timeline events available for this grant yet.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {activeTab === "documents" && (
          <div className="grievance-details-panel full-width">
            <div className="grievance-details-card">
              <div className="card-header">
                <h3>
                  <i className="bi bi-files"></i> Attached Documents
                </h3>
              </div>
              <div className="card-body">
                {allAttachments?.length > 0 ? (
                  <>
                    {/* Document categories */}
                    <ul className="document-categories">
                      <li className="category-active">All Documents</li>
                    </ul>

                    <div className="documents-grid">
                      {allAttachments.map((attachment, index) => (
                        <DocumentCard
                          filename={attachment.att_name}
                          attachmentId={attachment.grant_att_id} // grant_att_id, grv_att_id, or idcard_att_id
                          type="grant" // or whatever type needed for the API
                          onPreview={handleTimelineAttachmentPreview}
                          isLoading={isLoading}
                        />
                      ))}
                    </div>
                  </>
                ) : (
                  <div className="empty-state">
                    <div className="empty-icon">
                      <i className="bi bi-file-earmark-x"></i>
                    </div>
                    <p>No documents attached to this grant</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {activeTab === "update" && (
          <div className="grievance-details-panel full-width">
            <div className="grievance-details-card">
              <div className="card-header">
                <h3>
                  <i className="bi bi-pencil-square"></i> Update Status
                </h3>
              </div>
              <div className="card-body">
                <div className="update-form">
                  <div className="form-group">
                    <label htmlFor="comments">
                      <i className="bi bi-chat-text"></i> Remarks
                    </label>
                    <textarea
                      id="comments"
                      className="form-control"
                      rows="4"
                      value={comments}
                      onChange={(e) => setComments(e.target.value)}
                      placeholder="Add your remarks or notes"
                    ></textarea>
                  </div>

                  <div className="aresa-form-actions">
                    <button
                      className="aresa-button-secondary"
                      onClick={resetForm}
                      disabled={isSubmitting}
                      type="button"
                    >
                      <i className="bi bi-x-circle"></i> Cancel
                    </button>

                    <>
                      {/* Approve Button */}
                      <button
                        className="aresa-button-success"
                        onClick={handleApproveGrant}
                        disabled={isSubmitting || !comments}
                        type="button"
                      >
                        <i className="bi bi-check-circle"></i> Update Status
                      </button>
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {isLoading && <Loader></Loader>}
    </div>
  );
};

export default EscalatedGrantsDetails;
